import { Container, Text, TextStyle } from "pixi.js";
import { ButtonWithScaleAnimation } from "../../../common/components/ButtonWithScaleAnimation";
import { GameFont } from "../../../common/GameFont";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class ShieldField extends Container {
    private readonly commonResources: CommonResourcesPackage;

    private shieldsValueField: Text;
    private shieldsButton: ButtonWithScaleAnimation;

    public set shieldCount(value: number) {
        this.shieldsValueField.text = value > 0 ? `X${value}` : "";
        this.layout();
    }

    public constructor(commonResources: CommonResourcesPackage, value: number) {
        super();
        this.commonResources = commonResources;
        this.build();
        this.layout();
        this.shieldCount = value;
    }


    private build(): void {
        this.shieldsButton = new ButtonWithScaleAnimation(this.commonResources.assets_common_ui_top_panel_shield_png);
        this.addChild(this.shieldsButton);

        this.shieldsValueField = new Text("", new ShieldsValueTextStyle());
        this.shieldsButton.addChild(this.shieldsValueField);
    }

    private layout(): void {
        this.shieldsValueField.position.set(20, 39);
    }
}

class ShieldsValueTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 32,
            stroke: "#000000",
            strokeThickness: 5
        }));
    }
}
